import {IClientApp} from "../../../../../dash/domains/clientapps/models/clientapp.model";
import {IUserBrief} from "../../../../../dash/domains/users/users/models/user.model";

export interface INotification {
  id: number;
  title: string;
  description: string;
  image: string | null;
  priority: string;
  read: boolean;
  sticky: boolean;
  created_at: Date;
  updated_at: Date;
  redirect_url: string;
  view_count: number;
  click_count: number;
  text_color: string;
  background_color: string;
  action_color: string;
  response: string;
  user_id: number;
  user_full_name: string;
  published: boolean
  client_app: IClientApp | null
}

export interface INotificationBrief {
  id: number;
  created_at: Date;
  updated_at: Date;
  title: string;
  description: string;
  redirect_url: string;
  image: string | null;
  priority: string;
  read: boolean;
  sticky: boolean;
  published: boolean;
  text_color: string;
  background_color: string;
  action_color: string;
  view_count: number;
  click_count: number;
}

export interface INotificationDetail {
  id: number;
  created_at: Date;
  updated_at: Date;
  title: string;
  description: string;
  redirect_url: string;
  image: string | null;
  priority: string;
  read: boolean;
  sticky: boolean;
  published: boolean;
  text_color: string;
  background_color: string;
  action_color: string;
  view_count: number;
  click_count: number;
  response: string;
  user: IUserBrief | null;
  client_app: IClientApp | null
}

export class INotificationReq {
  title: string | null | undefined = ""
  description: string | null = null
  response: string | null = null
  image: string | null = null
  priority: string = Priorities.LOW
  sticky: boolean = false
  redirect_url: string | null = null
  text_color: string = "#000000"
  background_color: string = "#FFFFFF"
  action_color: string = "#004885"
  user_id: string | null = null
  client_app_id: number | null = null
}

export enum Priorities {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
  IMMEDIATE = 'IMMEDIATE'
}

export interface INotificationResponse {
  response: string
}
